import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse, Button } from 'react-bootstrap5';

import IconWithText from 'components/Widgets/IconWithText';
import ExternalLink from 'components/Widgets/ExternalLink';

export default function Archive({ talentAssessments }) {
  const [open, setOpen] = useState(false);

  const dateFormat = (value) => {
    if (!value) {
      return null;
    }

    const date = new Date(value);
    const options = { dateStyle: 'long', timeStyle: 'short' };

    return new Intl.DateTimeFormat('en-US', options).format(date);
  };

  if (talentAssessments.length === 0) {
    return null;
  }

  return (
    <>
      <Button
        variant="link"
        className="d-flex mb-3 collapsed text-decoration-none text-gray-900"
        onClick={() => setOpen(!open)}
        data-bs-toggle="collapse"
        data-bs-target="#talent-assessments-list"
        aria-controls="talent-assessments-list"
        aria-expanded={open}
      >
        {open ? 'Hide' : 'Show'}
        {' '}
        Archive

        <IconWithText
          iconClassName="chevron-icon small-icon icon-toggle"
          wrapperClassName="ms-2"
        />
      </Button>

      <Collapse in={open}>
        <ul
          id="talent-assessments-list"
          className="list-unstyled"
        >
          {talentAssessments.map((talentAssessment) => (
            <li key={talentAssessment.id}>
              <IconWithText
                iconClassName="article-icon bg-secondary"
                iconBg="medium-bg bg-gray-100"
                wrapperClassName="mb-3"
              >
                <>
                  <div className="small text-gray-700 fw-light">
                    {dateFormat(talentAssessment.attributes.completed_at)}
                  </div>

                  <div>
                    Talent Assessment
                  </div>

                  <ExternalLink
                    variant={null}
                    href={talentAssessment.attributes.url}
                    className="small"
                  >
                    Download Report
                  </ExternalLink>
                </>
              </IconWithText>
            </li>
          ))}
        </ul>
      </Collapse>
    </>
  );
}

Archive.propTypes = {
  talentAssessments: PropTypes.arrayOf(PropTypes.object).isRequired,
};
